import React from 'react';

const Certificate = () => {
    return (
        <div className="section-container black" style={{ "marginTop": "0px" }}>
            <div className='text-column'>
                <h2 className='text white large' style={{ 'textAlign': 'center' }}> Certificado de Conclusão</h2>
                <p className='text white' style={{ 'textAlign': 'center' }}> Esses certificados podem ser compartilhados em redes sociais como o LinkedIn e inseridos em informações curriculares</p>

            </div>
            <div className="image-column">
                <img
                    src="certificado.jpg"
                    alt="certificado"
                    style={{ 'maxHeight': '250px', 'maxWidth': '250px' }}

                />
            </div>
        </div>
    );
};

export default Certificate;